/**
 * ロール ID からカードサムネイル画像 URL を解決する共通ユーティリティ。
 *
 * `src/assets/images/card_role_<id>.webp` を `import.meta.url` で解決して
 * Vite ビルドに含める。存在しない ID（新規作成直後など）でもクラッシュしないよう
 * 呼び出し側で `<img onError>` フォールバックを当てる前提。
 */
export const roleImageUrl = (id: number): string =>
  new URL(`../assets/images/card_role_${id}.webp`, import.meta.url).href;
